import CryptoJS from 'crypto-js';

const secretKey = process.env.ENCRYPTION_SECRET_KEY || "asdfghjklmnbvcxzqwertyuiop"
export const encryptNumberAES = (num) => {
    // Encrypt the number as a string using AES

    const encrypted = CryptoJS.AES.encrypt(typeof num === "string" ? num : num?.toString(), secretKey).toString();
    console.log("encrypted", num, secretKey, encrypted);
    return encrypted;
};

export const decryptNumberAES = (encryptedNum) => {
    // Decrypt the number using AES
    const bytes = CryptoJS.AES.decrypt(encryptedNum, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
};
